export const FROZEN_DBKEY =
  'FROZEN_DBKEY: dbKey must be () => catalogScopeKey()' as const

export type FrozenDbKeyError = typeof FROZEN_DBKEY

export const IDENTITY_DB_KEYS = ['fuellox', 'IdentityPasswordLoginPage-method'] as const

export type IdentityDbKey = (typeof IDENTITY_DB_KEYS)[number]

export type LiveDbKey = () => string | undefined

export type SqliteDbKeyArg<K> = K extends LiveDbKey
  ? K
  : K extends IdentityDbKey
    ? K
    : FrozenDbKeyError

export function resolveSqliteDbKey (
  dbKey: LiveDbKey | IdentityDbKey,
): string | undefined {
  return typeof dbKey === 'function' ? dbKey() : dbKey
}
